import {gql} from 'graphql-request';
import {useGqlRequest} from '@/api/request';
import {QueryFunctionContext, useQuery} from '@tanstack/react-query';
import {DataSourceItem} from '../@types';

export const useMapDataSource = () => {
  const request = useGqlRequest({
    query: GET_DATA_SOURCE,
  });

  const queryFn = (
    context?: QueryFunctionContext
  ):
    | undefined
    | Promise<{
        result?: DataSourceItem[];
      }> => {
    return request(context);
  };

  const select = (data?: {result?: DataSourceItem[]}) => data?.result;

  return useQuery({
    queryFn,
    staleTime: 24 * 60 * 60 * 1000,
    queryKey: ['map/data-source'],
    select,
  });
};

const GET_DATA_SOURCE = gql`
  query dataSources {
    result: dataSources {
      baseDate
      data
      key
      seq
      source
    }
  }
`;
